import { render } from "./App.vue?vue&type=template&id=cb927434"
const script = {}

import "./App.vue?vue&type=style&index=0&id=cb927434&lang=css"

import exportComponent from "/home/diegoflores/Documents/projects/autocobro/PortalAutoCobro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__